<template>
    <div>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-table
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        :data="dataSet"
                >
                    <el-table-column align="center" type="selection" width="20" v-if="false"></el-table-column>
                    <el-table-column prop="MainSyncName" label="同步内容" ></el-table-column>
                    <el-table-column prop="MainFlag" label="同步状态" ></el-table-column>
                    <el-table-column prop="MainBeginTime" label="同步开始时间" ></el-table-column>
                    <el-table-column prop="MainEndTime" label="同步结束时间" ></el-table-column>
                    <el-table-column prop="CreateTime" label="创建时间" ></el-table-column>
                    <el-table-column prop="CreateUserID" label="创建人" ></el-table-column>
                    <el-table-column prop="Remark" label="备注" ></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <el-button type="primary" size="mini" @click="synchronous">同步</el-button>
                <el-table
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        :data="dataDetail"
                        @selection-change="handleSelectionChange">
                    <el-table-column align="center" type="selection" width="20"></el-table-column>
                    <el-table-column prop="SystemName" label="数据源" ></el-table-column>
                    <el-table-column prop="TableName" label="模块" ></el-table-column>
                    <el-table-column prop="DataContent" label="同步条数" align="right"></el-table-column>
                    <el-table-column prop="Flag" label="同步状态" ></el-table-column>
                    <el-table-column prop="LastTime" label="最后同步时间"></el-table-column>
                    <el-table-column prop="Remark" label="备注"></el-table-column>
                    <el-table-column prop="TimeCost" label="花费时间" align="right"></el-table-column>
                </el-table>
            </li>
        </ul>

        <el-dialog v-dialogDrag :visible.sync="synVisible" title="同步任务" width="40%" :close-on-click-modal="false">
            <el-table
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    height="500px"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                    :data="synData"
                    @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="20"></el-table-column>
                <el-table-column prop="name" label="模块" ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="handleVisible = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmSynchronous()" size="mini" :disabled="selectData.length == 0">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'syntask',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [],
                selectData: [],
                dataDetail: [],
                synData:[],
                synVisible: false,

            };
        },
        mounted: function () {
            let that = this;
            that.$limits.dragControllerDiv();
            that.getView()
        },
        methods: {
            headerCellClassName({ column, columnIndex }) {
                return 'col-blue';
            },
            handleSelectionChange(val) {
                let that = this
                that.selectData = val
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            getView() {
                let that = this
                that.dataSet = [
                    {
                        MainSyncID: 0,
                        MainSyncName: '主同步计划',
                        MainFlag:'同步完成',
                        MainBeginTime:'2023-4-23 16:21:52',
                        MainEndTime:'2023-4-23 16:21:55',
                        CreateTime:'2023-4-23 16:21:52',
                        CreateUserID:'管理员',
                        Remark:''
                    }
                ]
            },
            editInfo(){
                let that = this
                console.log('55555!')
                that.dataDetail = [
                    {
                        SystemName: 'syteline',
                        TableName:'Item mst',
                        DataContent:1191,
                        Flag:'同步完成',
                        LastTime:'2023-4-23 16:34:56',
                        Remark:'',
                        TimeCost: 634,
                    },
                    {
                        SystemName: 'syteline',
                        TableName:'ummst',
                        DataContent:56,
                        Flag:'同步完成',
                        LastTime:'2023-4-23 16:34:57',
                        Remark:'',
                        TimeCost: 235,
                    },
                    {
                        SystemName: 'syteline',
                        TableName:'prodcode_mst',
                        DataContent:789,
                        Flag:'同步完成',
                        LastTime:'2023-4-23 16:34:58',
                        Remark:'',
                        TimeCost: 567,
                    },
                ]
            },
            //查询
            search(){
                let that = this
            },
            synchronous(){
                let that = this
                that.synData = [
                    {
                        id:'1',
                        name:'税率信息',
                    },
                    {
                        id:'2',
                        name:'销售客户信息',
                    },
                    {
                        id:'3',
                        name:'销售订单管理',
                    },
                    {
                        id:'4',
                        name:'销售发货单',
                    },
                    {
                        id:'5',
                        name:'采购收货单',
                    },
                    {
                        id:'6',
                        name:'采购入库单',
                    },
                    {
                        id:'7',
                        name:'库存表信息',
                    },
                    {
                        id:'8',
                        name:'通用出库单',
                    },
                    {
                        id:'9',
                        name:'移库管理',
                    },
                    {
                        id:'10',
                        name:'材料入库单',
                    },
                    {
                        id:'11',
                        name:'采购入库事务',
                    },
                    {
                        id:'12',
                        name:'材料入库事务',
                    },
                    {
                        id:'13',
                        name:'通用出库事务',
                    },
                    {
                        id:'14',
                        name:'移库库存事务',
                    },
                    {
                        id:'15',
                        name:'销售发货事务',
                    },
                    {
                        id:'16',
                        name:'物料主文件',
                    },
                    {
                        id:'17',
                        name:'计量单位同步',
                    },
                    {
                        id:'18',
                        name:'项目信息同步',
                    },
                    {
                        id:'19',
                        name:'存货类别同步',
                    },
                    {
                        id:'20',
                        name:'工作中心同步',
                    },
                    {
                        id:'21',
                        name:'工序类型同步',
                    },
                    {
                        id:'22',
                        name:'工艺信息主表',
                    },
                    {
                        id:'23',
                        name:'BOM信息同步',
                    },
                    {
                        id:'24',
                        name:'供应商信息同步',
                    },
                    {
                        id:'25',
                        name:'采购订单主表',
                    },
                    {
                        id:'26',
                        name:'生产工单头信息同步',
                    },
                    {
                        id:'27',
                        name:'生产料表信息同步',
                    },
                    {
                        id:'28',
                        name:'生产发料主表信息同步',
                    },
                    {
                        id:'29',
                        name:'生产发料红字主表信息同步',
                    },
                    {
                        id:'30',
                        name:'汇报历史表信息同步',
                    },
                    {
                        id:'31',
                        name:'生产入库主表信息同步',
                    },
                ]
                that.synVisible = true
            },
            confirmSynchronous(){
                let that = this
                that.synVisible = false
            }
        }
    };
</script>

<style scoped lang="less">
    table{
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
